<p-toast></p-toast>
<p-card styleClass="p-card-shadow mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                    icon="pi pi-upload" class="p-button-help"></button>

                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>

        </p-toolbar>
        <p-table #miSurvey [value]="dayWise" dataKey="AppId_ProgID" [rows]="10" [paginator]="true" [globalFilterFields]="[
        'Date',
        'ChallanDeposited',
        'AmountDeposited', 
        'ChallanRejected',
        'AmountRejected',
        'DayOfWeekName'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
            currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
            [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)"
            [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'CHALLAN_RECONCILIATION_DAY_REPORT'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="Date_sort">{{'DATE'| translate}}
                        <p-columnFilter type="text" field="Date_filter" display="menu"></p-columnFilter>
                        <p-sortIcon field="Date_sort"></p-sortIcon>
                    </th>
                    <th pSortableColumn="DayOfWeekName">{{'DAY'| translate}}
                        <p-columnFilter type="text" field="DayOfWeekName" display="menu"></p-columnFilter>
                        <p-sortIcon field="DayOfWeekName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ChallanDeposited">{{'CHALLAN_DEPOSITED'| translate}}
                        <p-columnFilter type="text" field="ChallanDeposited" display="menu"></p-columnFilter>
                        <p-sortIcon field="ChallanDeposited"></p-sortIcon>
                    </th>
                    <th pSortableColumn="AmountDeposited">{{'AMOUNT_DEPOSITED'| translate}}
                        <p-columnFilter type="text" field="AmountDeposited" display="menu"></p-columnFilter>
                        <p-sortIcon field="AmountDeposited"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ChallanRejected">{{'CHALLAN_REJECTED'| translate}}
                        <p-columnFilter type="text" field="ChallanRejected" display="menu"></p-columnFilter>
                        <p-sortIcon field="ChallanRejected"></p-sortIcon>
                    </th>
                    <th pSortableColumn="AmountRejected">{{'AMOUNT_REJECTED'| translate}}
                        <p-columnFilter type="text" field="AmountRejected" display="menu"></p-columnFilter>
                        <p-sortIcon field="AmountRejected"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dayWise>
                <tr>
                    <td>{{dayWise?.Date_filter}}</td>
                    <td>{{dayWise?.DayOfWeekName}}</td>
                    <td><a class="link_pointer"
                            (click)="showMaximizableDialog_challan('ChallanDeposited', dayWise.Date, dayWise.ChallanDeposited)">{{dayWise.ChallanDeposited}}</a>
                    </td>
                    <td>{{dayWise.AmountDeposited}}</td>
                    <td><a class="link_pointer"
                            (click)="showMaximizableDialog_challan('challanRejected', dayWise.Date, dayWise.ChallanRejected)">{{dayWise.ChallanRejected}}</a>
                    </td>
                    <td>{{dayWise.AmountRejected}}</td>

                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr>
                    <td colspan="2"> Total</td>
                    <td>{{totalChallanDeposited | number:'1.0-2'}}</td>
                    <td>{{totalAmountDeposited | number:'1.0-2'}}</td>
                    <td>{{totalChallanRejected | number:'1.0-2'}}</td>
                    <td>{{totalAmountRejected | number:'1.0-2'}}</td>
                </tr>
                <tr>
                    <td colspan="2"> Grand Total</td>
                    <td>{{grandTotalChallanDeposited | number:'1.0-2'}}</td>
                    <td>{{grandTotalAmountDeposited | number:'1.0-2'}}</td>
                    <td>{{grandTotalChallanRejected | number:'1.0-2'}}</td>
                    <td>{{grandTotalAmountRejected | number:'1.0-2'}}</td>
                </tr>
            </ng-template>


        </p-table>
    </div>
</p-card>
<p-dialog class="drilldown_details" [baseZIndex]="-100"
    header="Drill Down Month wise {{challanName}} Report Of  {{value}} " [(visible)]="displayMaximizable" [modal]="true"
    [style]="{width: '100%'}" [draggable]="false" [resizable]="false">
    
    <app-challan-reconciliation-day-drill-down-report *ngIf="displayMaximizable"
        [drilldownDetails]="drilldownDetails"></app-challan-reconciliation-day-drill-down-report>
</p-dialog>